import { render, staticRenderFns } from "./ChangeQueueModal.vue?vue&type=template&id=139c3bb2&"
import script from "./ChangeQueueModal.vue?vue&type=script&lang=js&"
export * from "./ChangeQueueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports